import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Home from './pages/Home';
import Unsuccessful from './pages/Unsuccessful';
import Successful from './pages/Successful';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/error" element={<Unsuccessful />} />
        <Route path="/success" element={<Successful />} />
        <Route path="*" element={<Navigate to="/"/>} />
      </Routes>
    </Router>
  )
}
export default App